import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/sanjaysharma/Workspaces/intellij/sanjay-sharma-portfolio /src/components/CopyNotification.tsx");
;
import(/* webpackMode: "eager" */ "/Users/sanjaysharma/Workspaces/intellij/sanjay-sharma-portfolio /src/styles/index.css");
